<template>
  <span>
    <template v-for="(part, index) in parts">
      <a
        v-if="part.href"
        :key="`link-${index}`"
        :href="part.href"
        target="_blank"
        rel="noopener noreferrer"
        :class="{ 'is-bold': part.isBold }"
      >{{ part.text }}</a>
      <strong
        v-else-if="part.isBold"
        :key="`bold-${index}`"
      >
        <mark
          v-if="part.isMatch"
          class="search-highlight"
        >{{ part.text }}</mark>
        <span v-else>{{ part.text }}</span>
      </strong>
      <mark
        v-else-if="part.isMatch"
        :key="`match-${index}`"
        class="search-highlight"
      >{{ part.text }}</mark>
      <span
        v-else
        :key="`text-${index}`"
      >{{ part.text }}</span>
    </template>
  </span>
</template>

<script>
/**
 * Renderiza los segmentos que devuelve utils/richText: negritas, coincidencias
 * de búsqueda resaltadas y links.
 */
export default {
    name: 'HighlightedText',
    props: {
        parts: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped>
a.is-bold {
  font-weight: 700;
}

.search-highlight {
  background: linear-gradient(120deg, rgba(62, 182, 184, 0.15) 0%, rgba(62, 182, 184, 0.25) 100%);
  color: var(--unc-azul);
  border-radius: 3px;
  padding: 1px 0;
  font-weight: 500;
}
</style>
